import { GRAY20, H5 } from 'global-styles';
import { useRouter } from 'next/router';
import styled from 'styled-components';

type Props = {
  text: { en: string; ko: string };
};

const NoPost = ({ text }: Props) => {
  const { locale } = useRouter();

  return (
    <NoPostContainer>
      <H5>{text[locale]}</H5>
    </NoPostContainer>
  );
};

export default NoPost;

const NoPostContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 500px;
  color: ${GRAY20};
`;
